// ===== Discount Code Handler for BlingBlingYarn =====
(function() {
  'use strict';

  const DISCOUNT_FEEDBACK_CLASSES = 'discount-feedback-success discount-feedback-error discount-feedback-info'.split(' ');

  // Application state
  let lastAppliedCode = '';
  const cartCache = {};

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Main cart page
    setupDiscountUI('discount-code-input', 'apply-discount-btn', 'discount-feedback');
    // Cart drawer
    setupDiscountUI('cart-drawer-discount-input', 'cart-drawer-apply-discount-btn', 'cart-drawer-discount-feedback');

    // Listen for cart changes to update discount status display
    document.addEventListener('cart:change', function(e) {
      const cartData = e.detail && e.detail.cart;
      if (cartData) {
        updateDiscountDisplay(cartData);
      }
    });
  }

  function setupDiscountUI(inputId, btnId, feedbackId) {
    const input = document.getElementById(inputId);
    const btn = document.getElementById(btnId);
    const feedback = document.getElementById(feedbackId);

    if (!input || !btn || !feedback) return;

    // Apply on button click
    btn.addEventListener('click', function() {
      applyDiscountCode(input, feedback);
    });

    // Apply on Enter key
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscountCode(input, feedback);
      }
    });

    // Real-time visual feedback on input change
    input.addEventListener('input', function() {
      // If user clears the input while a discount is applied, show hint
      if (!this.value.trim() && lastAppliedCode) {
        feedback.innerHTML = '<span style="color:#666">💡 Current discount applied. Clear or enter new code.</span>';
        feedback.style.display = 'block';
      } else if (!this.value.trim()) {
        feedback.innerHTML = '';
        feedback.style.display = 'none';
      }
    });
  }

  function applyDiscountCode(input, feedback) {
    const code = input.value.trim();
    
    if (!code) {
      showFeedback(feedback, 'Please enter a discount code.', 'info');
      return;
    }

    // Show loading state
    const btn = input.closest('cart-discount') ? 
      input.closest('cart-discount').querySelector('button') : 
      document.getElementById(input.id.replace('input', 'btn') || 'apply-discount-btn');
    
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Checking...';
    }

    showFeedback(feedback, '⏳ Checking discount code...', 'info');

    // Get the cart subtotal from the DOM
    const subtotalEl = document.querySelector('[data-cart-subtotal], .bcpo-cart-original-total, .cart-items-subtotal, [data-cart-total]');
    let subtotal = 0;
    const cartTotalEl = document.querySelector('.cart-recap .text-lg:last-child span, .cart-drawer__button-price');
    if (cartTotalEl) {
      const match = cartTotalEl.textContent.trim().replace('$', '').replace(',', '');
      subtotal = parseFloat(match) || 0;
    }
    // Fallback: parse from cart.js
    if (!subtotal) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          subtotal = cart.total_price / 100;
          checkDiscount(code, subtotal, input, feedback, btn);
        })
        .catch(function() {
          checkDiscount(code, subtotal, input, feedback, btn);
        });
    } else {
      checkDiscount(code, subtotal, input, feedback, btn);
    }
  }

  function checkDiscount(code, subtotal, input, feedback, btn) {
    // Call the backend discount proxy via Cloudflare tunnel
    // The tunnel URL changes on each restart; we use a DNS-friendly approach
    var discountApiUrl = 'https://electric-reconstruction-polo-temporarily.trycloudflare.com/discount';
    
    fetch(discountApiUrl + '?code=' + encodeURIComponent(code) + '&subtotal=' + encodeURIComponent(subtotal.toFixed(2)))
      .then(function(response) { return response.json(); })
      .then(function(result) {
        if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
        
        if (result.valid) {
          lastAppliedCode = code;
          
          // SUCCESS - display real discount info
          showFeedback(feedback,
            '✅ <strong style="font-size:1.2em;">Discount Applied! ✅</strong><br>' +
            '<span style="font-size:1.0em;color:#155724;">Code: ' + result.title + '</span><br>' +
            '<span style="font-size:1.4em;font-weight:bold;">You save: <span style="color:#dc3545;">' + result.discount_amount + '</span></span><br>' +
            '<span style="font-size:1.3em;font-weight:bold;">New subtotal: <span style="color:#28a745;">' + result.new_total + '</span></span><br>' +
            '<span style="font-size:0.9em;color:#155724;">Discount will be applied at checkout</span>',
            'success'
          );
          
          // Also try cart/update.js to sync the discount to server
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount_code: code }),
            credentials: 'same-origin'
          }).catch(function() {});
          
          // Dispatch cart:refresh
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          input.value = '';

        } else {
          // Check if the error includes min order info (for "add more" guidance)
          var hasShortfall = result.shortfall && result.shortfall > 0;
          if (hasShortfall) {
            showFeedback(feedback,
              '🛒 <strong style="font-size:1.1em;">Almost there!</strong><br>' +
              '<span style="font-size:1.0em;">' + result.error + '</span><br>' +
              '<span style="font-size:1.05em;font-weight:bold;display:block;margin-top:6px;color:#28a745;">' +
              'Add just <span style="font-size:1.2em;color:#dc3545;">$' + result.shortfall.toFixed(2) + '</span> more to your cart!</span>',
              'info'
            );
          } else {
            showFeedback(feedback,
              '❌ <strong>Discount code invalid</strong><br>' +
              '<span style="font-size:0.95em;color:#721c24;">' + (result.error || 'Please check the code and try again.') + '</span>',
              'error'
            );
          }
        }
      })
      .catch(function(err) {
        if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
        showFeedback(feedback,
          '❌ <strong>Unable to verify discount code</strong><br>' +
          '<span style="font-size:0.95em;color:#721c24;">Please try again or enter the code at checkout.</span>',
          'error'
        );
      });
  }

  function updateDiscountDisplay(cartData) {
    // This is called when cart changes to update discount badges
    // The Liquid template already handles rendering discounts via cart.cart_level_discount_applications
  }

  function showFeedback(feedbackEl, message, type) {
    if (!feedbackEl) return;
    
    feedbackEl.style.display = 'block';
    
    // Remove old classes
    DISCOUNT_FEEDBACK_CLASSES.forEach(function(cls) {
      feedbackEl.classList.remove(cls);
    });

    let color;
    let bg;
    let border;

    switch(type) {
      case 'success':
        color = '#155724';
        bg = '#d4edda';
        border = '#c3e6cb';
        break;
      case 'error':
        color = '#721c24';
        bg = '#f8d7da';
        border = '#f5c6cb';
        break;
      case 'info':
      default:
        color = '#0c5460';
        bg = '#d1ecf1';
        border = '#bee5eb';
        break;
    }

    feedbackEl.style.color = color;
    feedbackEl.style.backgroundColor = bg;
    feedbackEl.style.border = '1px solid ' + border;
    feedbackEl.style.padding = '8px 12px';
    feedbackEl.style.borderRadius = '6px';
    feedbackEl.style.fontSize = '14px';
    feedbackEl.style.fontWeight = '500';
    feedbackEl.style.lineHeight = '1.4';
    feedbackEl.innerHTML = message;
  }
})();

